import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header.js';
import Footer from './components/Footer.js';
import Cart from './components/Cart.js';

import ProductDetails from './pages/ProductDetails.js';
import Home from './pages/Home.js';
import About from './pages/About.js';

import Search from './pages/Search.js';
import NotFound from './pages/NotFound.js';

// --- CATEGORY IMPORTS ---
import CategoryIndex from './pages/CategoryIndex.js';
import CategoryPage from './pages/CategoryPage.js';
import TagPage from './pages/TagPage.js';
import BrandPage from './pages/BrandPage.js';

// --- LEGAL PAGES IMPORTS ---
import PrivacyPolicy from './pages/legal/PrivacyPolicy.js';
import TermsOfService from './pages/legal/TermsOfService.js';
import RefundPolicy from './pages/legal/RefundPolicy.js';

import { DarkModeProvider } from './DarkModeContext.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';

function App() {
  return (
   <DarkModeProvider>
      <Router>
        <div className="App">
          <Header className="sticky-header" />
          <div className="content-wrapper">
            <main className="site-main">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/about" element={<About />} />
                
                {/* --- LEGAL ROUTES --- */}
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<TermsOfService />} />
                <Route path="/refund-policy" element={<RefundPolicy />} />
                
                {/* --- NEW ROUTES --- */}
                {/* 1. Master Page (Shows all categories/tags) */}
                <Route path="/category" element={<CategoryIndex />} />
                
                {/* 2. Specific Category Feed */}
                <Route path="/category/:categoryName" element={<CategoryPage />} />
                
                {/* 3. Specific Tag Feed */}
                <Route path="/tag/:tagName" element={<TagPage />} />
                {/* ------------------ */}
                <Route path="/brand/:brandName" element={<BrandPage />} />
                <Route path="/product/:id" element={<ProductDetails />} />
                <Route path="/search" element={<Search />} />
               
                <Route path="*" element={<NotFound />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </div>
      </Router>
    </DarkModeProvider>
  );
}

export default App;